import React, { Component, useState } from 'react'
import './home.css';
import 'react-input-range/lib/css/index.css';
import { isMobile } from 'react-device-detect';

import Spinner from '../components/Spinner';
import PortionSelector from '../components/PortionSelector';
import TwoColumns from '../layouts/TwoColumns';
import { PortionsContext } from '../context/PortionsContext';
import MapContainer from '../components/MapContainer';
import HomeHeader from '../components/headers/Home';
import MobileLayout from '../layouts/MobileLayout';
import Map from "../components/map";

const HomeMapContainer = ({ history, context, mapHeight, showInfo, largeMode }) => {
    const [showParcelInfo, setShowParcelInfo] = useState(false);
    const [parcelInfo, setParcelInfo] = useState(null);
    const setCurrentLoteamiento = (parcel) => {
        setShowParcelInfo(true);
        setParcelInfo(parcel);
        // this.context.setCurrentLoteamiento
        /* this.setParcelInfo(null);

        if (this.props.action == 'navigate') {
            history.push('/loteamientos/mapa');
        }

        context.setCurrentLoteamiento(parcel); */
    }

    const goToCurrentLoteamiento = (parcel) => {
        history.push('/loteamientos/mapa');

        context.setCurrentLoteamiento(parcel);
    }

    const hideParcelInfo = () => {
        setShowParcelInfo(false);
        setParcelInfo(null);
    }

    return (
        <MapContainer action="navigate" history={history} mapHeight={mapHeight} showInfo={false} navigation={true}>
            <Map
                ref={context.map}
                action="show"
                showParcelInfo={showParcelInfo}
                hideParcelInfo={hideParcelInfo}
                parcelInfo={parcelInfo}
                unsetLoteamiento={context.unsetLoteamiento}
                setCurrentLoteamiento={setCurrentLoteamiento}
                goToCurrentLoteamiento={goToCurrentLoteamiento}
                name={context.selectedLoteamiento?.properties.name}
                phone={context.selectedLoteamiento?.properties.whatsapp_number}
                markers={context.portions || []}
                currentLoteamientoId={context.selectedLoteamiento?.id}
                showPortionStatus={false}
                parcels={context.parcels}
                left="var(--filters-width)"
                viewport={{
                    ...context.viewport,
                    height: mapHeight
                }}
                blocksCentralPoints={context.blocksCentralPoints}
                history={history}
                largeMode={"home-page"}
                hasInfo={false}
            ></Map>
        </MapContainer>
    )
}

class Home extends Component {
    constructor(props) {
        super(props);
    }

    viewport = {
        // height: "calc(100vh - var(--header-height) - var(--detailHeaders-height))",
        height: "100vh",
    }

    render() {
        if (isMobile) {
            return <MobileLayout
                {...this.props}
                content={<PortionSelector
                    history={this.props.history}
                    rightClass="home-column home-column-right home-mobile"
                    navigation={true}
                />}
            />
        }


        return (<TwoColumns
            {...this.props}
            classContainer="map-container"
            header={<HomeHeader />}
            left={
                <>
                    {
                        this.context.isLoading && <div className="spinner-container" style={{
                            minHeight: this.viewport.height,
                            height: `calc(100vh + var(--detailHeaders-height) - var(--header-height) - var(--detailHeaders-height)`,
                        }}><Spinner /></div>
                    }

                    {!this.context.isLoading && <HomeMapContainer
                        context={this.context}
                        mapHeight="calc(100vh - var(--header-height)"
                        history={this.props.history}
                        showInfo={this.props.showInfo}
                        largeMode={this.props.largeMode}
                    />}
                </>
            }
            right={<PortionSelector history={this.props.history} style={{ marginTop: '-25px' }} navigation={true} />}
        />
        )
    }
}

Home.contextType = PortionsContext;

export default Home;
